import { render, staticRenderFns } from "./ResultsUser.vue?vue&type=template&id=56e6e536"
import script from "./ResultsUser.vue?vue&type=script&lang=js"
export * from "./ResultsUser.vue?vue&type=script&lang=js"
import style0 from "./ResultsUser.vue?vue&type=style&index=0&id=56e6e536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports